/* eslint-disable import/no-useless-path-segments */
import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Avatar, Box, Container, Typography } from '@mui/material';
// sections
import { Link } from 'react-router-dom';
import SignupForm from '../../src/sections/auth/signup/SignupForm';


// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    backgroundColor: "#012367"
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(1, 5),
}));


function SignupPage  ()  {
  return (
    <>
  <Helmet>
        <title> Signup | BFD - Admin </title>
      </Helmet>

      <StyledRoot>
       
        <Container maxWidth="sm">
          <StyledContent>
          <Box sx={{ height: '160px', width: "100%"}}>
        <Avatar src={'/assets/images/companylogo.jpg'} alt="" sx={{ height: 'auto', width: "50%", mx: "auto"}}/>
      </Box>

            <Typography variant="h3" sx={{  mt: 5, mb: 2, mx: 'auto', color: 'white' }}>
              Welcome PslCorp Signup
            </Typography>
            <SignupForm />
            <Link className='my-2 text-white' to={'/'}>Login your account ? </Link>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  )
}

export default SignupPage




